<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="small-banner"  title=" Our Mission" subtitle="  Our Mission" ></app-page-banner>
        
       <div class="container pt-0 pb-5">
        <div class="row align-items-center pt-0 pb-5">
            <!-- Left Side: Image -->
            <div class="col-lg-6 col-md-12 m-b10">
                <div class="image-container text-center mt-5 mb-4">
                    <img src="assets/images/sm1.jpg" alt="Welcome to Soul Space" class="img-fluid rounded-img shadow-img">
                </div>
            </div>
        
            <!-- Right Side: Text Content -->
            <div class="col-lg-6 col-md-12">
                <div class="text-content">
                    <div class="separator-line mb-4"></div>
                    <h5>Our Mission </h5>
                    <p class="section-body">
                        At Soul Space, we believe that every student deserves a safe and nurturing environment to explore their emotions, develop resilience, and cultivate mental well being. Our mission is to transform schools into havens of emotional growth and self-discovery

                    </p>
        
                    
                </div>
            </div>
        </div>
    </div>
        
              

    </div>
    <!-- CONTENT END -->

    <app-footer1></app-footer1>

</div>

<app-loader></app-loader>
